import api from '@/services/api';

export default {
  async getTemplate(templateId) {
    try {
      let response = await api.get(`Templates/${templateId}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return null;
    } catch (ex) {
      console.error(ex);
      return null;
    }
  },
  async getDropdownByPropertyId(propertyId) {
    try {
      let response = await api.get(`Templates/Dropdown?propertyId=${propertyId}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async getDropdown() {
    try {
      let response = await api.get(`Templates/Dropdown`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async getAllByPropertyId(propertyId, includeArchived) {
    try {
      let response = await api.get(`Templates?propertyId=${propertyId}&includeArchived=${includeArchived}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async getAll(includeArchived) {
    try {
      let response = await api.get(`Templates?includeArchived=${includeArchived}`);
      if (response && response.status == 200 && response.data) {
        return response.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async getGLAccountsByGroupTypeId(templateId, groupTypeId) {
    return this.getGLAccounts(templateId, groupTypeId, true, true);
  },
  async getExcludedGLAccounts(templateId, groupTypeId) {
    return this.getGLAccounts(templateId, groupTypeId, false, true);
  },
  async getGLAccounts(templateId, groupTypeId, includeAssigned, includeUnassigned) {
    try {
      let response = await api.get(`Templates/${templateId}/GLAccounts?groupTypeId=${groupTypeId}&includeAssigned=${includeAssigned}&includeUnassigned=${includeUnassigned}`);
      if (response && response.status == 200 && response.data && response.data.data) {
        return response.data.data;
      }
      return [];
    } catch (ex) {
      console.error(ex);
      return [];
    }
  },
  async createTemplate(title, sortType, propertyIds) {
    try {
      let response = await api.post('Templates', {
        title: title,
        sortType: sortType,
        properties: propertyIds
      });
      if (response && response.status == 200 && response.data) {
        return { success: true, data: response.data };
      } else {
        return { success: false, data: (response && response.error) ? response.error : 'Unable to create template' };
      }
    } catch (ex) {
      console.error(ex);
      return { success: false, data: ex };
    }
  },
  async updateTemplate(templateId, title, propertyIds, sortType, lastModifiedTimestamp) {
    try {
        let response = await api.put('Templates', {
          templateId: templateId,
          title: title,
          properties: propertyIds,
          sortType: sortType,
          lastModifiedTimestamp: lastModifiedTimestamp
        });
        if (response && response.status == 200 && response.data) {
          return { success: true, data: response.data };
        } else {
          return { success: false, data: (response && response.error) ? response.error : 'Unable to update template' };
        }
      } catch (ex) {
        console.error(ex);
        return { success: false, data: ex };
      }
  },
  async copyTemplate(templateId) {
    try {
      let response = await api.post(`Templates/${templateId}/Copy`);
      if (response && response.status == 200 && response.data) {
        return { success: true, data: response.data };
      } else {
        return { success: false, data: (response && response.error) ? response.error : 'Unable to copy template' };
      }
    } catch (ex) {
      console.error(ex);
      return { success: false, data: ex };
    }
  },
  async archiveTemplate(templateId, archive) {
    try {
      let response = await api.put(`Templates/${templateId}/Archive?archive=${archive}`);
      if (response && response.status == 200) {
        return { success: true, data: response.data };
      } else {
        return { success: false, data: (response && response.error) ? response.error : `Unable to ${archive ? 'archive' : 'unarchive'} template` };
      }
    } catch (ex) {
      console.error(ex);
      return { success: false, data: ex };
    }      
  }
}
